import { render, staticRenderFns } from "./CatalogueSidebar.vue?vue&type=template&id=f24e6dc8&scoped=true"
import script from "./CatalogueSidebar.vue?vue&type=script&lang=js"
export * from "./CatalogueSidebar.vue?vue&type=script&lang=js"
import style0 from "./CatalogueSidebar.vue?vue&type=style&index=0&id=f24e6dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24e6dc8",
  null
  
)

export default component.exports